import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import TagPill from "@/components/base/TagPill";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  const [featured, ...rest] = articles;

  return (
    <section className="border-y border-background-200/80 bg-background-100 py-16 md:py-20">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="IN-DEPTH"
            title="深度解读：把热闹拆成逻辑"
            description="从评估框架到同框细节，我们用可复核的分析，帮你把一场热闹读成一条门道。"
          />
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            全部解读
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <article className="group lg:col-span-7">
            <Link to={`/articles/${featured.slug}`} className="block h-64 w-full overflow-hidden rounded-lg md:h-80">
              <img
                src={featured.coverImage}
                alt={`${featured.title}配图`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </Link>
            <div className="mt-5">
              <TagPill variant="accent">{featured.category}</TagPill>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <Link to={`/articles/${featured.slug}`} className="transition-colors hover:text-primary-700">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {featured.excerpt}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span>{featured.author}</span>
                <span className="h-3 w-px bg-background-300" />
                <span>{featured.date}</span>
                <span className="h-3 w-px bg-background-300" />
                <span>{featured.readTime}</span>
              </div>
            </div>
          </article>

          <div className="flex flex-col divide-y divide-background-200 lg:col-span-5">
            {rest.slice(0, 3).map((item) => (
              <article key={item.slug} className="group flex gap-4 py-5 first:pt-0">
                <Link
                  to={`/articles/${item.slug}`}
                  className="block h-24 w-28 shrink-0 overflow-hidden rounded-md md:w-32"
                >
                  <img
                    src={item.coverImage}
                    alt={`${item.title}配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </Link>
                <div className="min-w-0 flex-1">
                  <span className="text-xs font-medium text-primary-600">{item.category}</span>
                  <h3 className="mt-1.5 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-[15px]">
                    <Link to={`/articles/${item.slug}`} className="transition-colors hover:text-primary-700">
                      {item.title}
                    </Link>
                  </h3>
                  <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span>{item.date}</span>
                    <span className="h-3 w-px bg-background-300" />
                    <span>{item.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}